// extracted by mini-css-extract-plugin
export default {"container":"SafeZone_container__MLI5W","buttons":"SafeZone_buttons__CmafM","buttons_icon":"SafeZone_buttons_icon__Qa-k+","button":"SafeZone_button__OnigU"};